import { Injectable, WritableSignal } from '@angular/core';
import { AccountMenuKey } from '@src/app/shared/dialogs/account-management.dialog/account-management.dialog.component';
import { environment } from '@src/environments/environment';
import { isProfilingEnabled } from '@src/app/core/utils/feature-flags.util';
import { BehaviorSubject } from 'rxjs';
import { CustomMenuItem } from '../types/menu-item.type';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class MenuDataService {
  public toggleMenuBar: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private translate: TranslateService) {}

  getMenuListWorkSpace(
    accountManagementDialogVisible: WritableSignal<boolean>,
    initialSelectedMenu: WritableSignal<AccountMenuKey>,
    isPoseedorFinalIntegral: boolean = false,
    isPoseedorFinalCE: boolean = false,
    isProductor: boolean = false,
  ): CustomMenuItem[] {
    const isPF = isPoseedorFinalIntegral || isPoseedorFinalCE;
    const isPFPuro = isProfilingEnabled() && isPF && !isProductor;
    const isProdWithPF = isProfilingEnabled() && isPF && isProductor;
    return [
      {
        label: this.translate.instant('menu.workspace.home'),
        primeIcon: 'pi pi-home',
        route: '/home',
        childs: null,
        isChildVisible: false,
      },
      ...(isPFPuro
        ? [
            {
              label: this.translate.instant(
                'menu.workspace.wasteDataManagement',
              ),
              primeIcon: 'pi pi-file-edit',
              route: '/waste-data-management',
              childs: null,
              isChildVisible: false,
            },
          ]
        : [
            {
              label: this.translate.instant('menu.workspace.procedures'),
              primeIcon: 'pi pi-file-edit',
              route: null,
              childs: [
                {
                  label: this.translate.instant(
                    'menu.workspace.packagingDeclaration',
                  ),
                  primeIcon: 'pi pi-file',
                  route: '/home/packaging-declaration',
                  childs: null,
                  isChildVisible: false,
                },
                {
                  label: this.translate.instant(
                    'menu.workspace.producersRegistration',
                  ),
                  primeIcon: 'pi pi-users',
                  route: '/home/producers-registration',
                  childs: null,
                  isChildVisible: false,
                },
                {
                  label: this.translate.instant(
                    'menu.workspace.preventionPlans',
                  ),
                  primeIcon: 'pi pi-shield',
                  route: '/home/prevention-plans',
                  childs: null,
                  isChildVisible: false,
                },
                {
                  label: this.translate.instant('menu.workspace.auditReport'),
                  primeIcon: 'pi pi-chart-line',
                  route: '/home/audit-report',
                  childs: null,
                  isChildVisible: false,
                },
                ...(isProdWithPF
                  ? [
                      {
                        label: this.translate.instant(
                          'menu.workspace.wasteDataManagement',
                        ),
                        primeIcon: 'pi pi-file-edit',
                        route: '/waste-data-management',
                        childs: null,
                        isChildVisible: false,
                      },
                    ]
                  : []),
              ],
              isChildVisible: false,
            },
          ]),
      {
        label: this.translate.instant('menu.workspace.services'),
        primeIcon: 'pi pi-sitemap',
        route: null,
        childs: [
          {
            label: this.translate.instant(
              'menu.workspace.complianceAndAdvisory',
            ),
            primeIcon: 'pi pi-check-square',
            route: ['/services'],
            queryParams: {
              category: 'compliance',
            },
            childs: null,
            isChildVisible: false,
          },
          {
            label: this.translate.instant('menu.workspace.ecodesignSolutions'),
            primeIcon: 'pi pi-lightbulb',
            route: ['/services'],
            queryParams: {
              category: 'ecodesign',
            },
            childs: null,
            isChildVisible: false,
          },
          {
            label: this.translate.instant(
              'menu.workspace.circularEconomyTraining',
            ),
            primeIcon: 'pi pi-graduation-cap',
            route: ['/services'],
            queryParams: {
              category: 'training',
            },
            childs: null,
            isChildVisible: false,
          },
          {
            label: this.translate.instant(
              'menu.workspace.environmentalAwareness',
            ),
            primeIcon: 'pi pi-globe',
            route: ['/services'],
            queryParams: {
              category: 'awareness',
            },
            childs: null,
            isChildVisible: false,
          },
        ],
        isChildVisible: false,
      },
      {
        label: this.translate.instant('menu.workspace.accountManagement'),
        iconImage: 'assets/icons/building-office.svg',
        route: null,
        childs: [
          {
            label: this.translate.instant('menu.workspace.contracts'),
            primeIcon: 'pi pi-file',
            command: () => {
              initialSelectedMenu.set('contracts');
              accountManagementDialogVisible.set(true);
            },
            childs: null,
            isChildVisible: false,
          },
          {
            label: this.translate.instant('menu.workspace.billingAndBankData'),
            primeIcon: 'pi pi-credit-card',
            route: '/account-management/billing',
            childs: null,
            isChildVisible: false,
          },
          {
            label: this.translate.instant('menu.workspace.contacts'),
            primeIcon: 'pi pi-users',
            route: '/account-management/contacts',
            childs: null,
            isChildVisible: false,
          },
          {
            label: this.translate.instant('menu.workspace.companyData'),
            primeIcon: 'pi pi-building',
            command: () => {
              initialSelectedMenu.set('company-data');
              accountManagementDialogVisible.set(true);
            },
            childs: null,
            isChildVisible: false,
          },
          {
            label: this.translate.instant('menu.workspace.addresses'),
            primeIcon: 'pi pi-map-marker',
            command: () => {
              initialSelectedMenu.set('addresses');
              accountManagementDialogVisible.set(true);
            },
            childs: null,
            isChildVisible: false,
          },
        ],
        isChildVisible: false,
      },
      {
        label: this.translate.instant('menu.workspace.requests'),
        primeIcon: 'pi pi-inbox',
        route: '/requests',
        childs: null,
        isChildVisible: false,
      },
    ];
  }
  getMenuListHub(
    isPoseedorFinalIntegral: boolean = false,
    isPoseedorFinalCE: boolean = false,
    isProductor: boolean = false,
  ): CustomMenuItem[] {
    const isPF = isPoseedorFinalIntegral || isPoseedorFinalCE;
    const isPFPuro = isProfilingEnabled() && isPF && !isProductor;
    return [
      {
        label: this.translate.instant('menu.hub.news'),
        primeIcon: 'pi pi-book',
        route: '/news',
        childs: null,
        isChildVisible: false,
      },
      ...(!isPFPuro
        ? [
            {
              label: this.translate.instant('menu.hub.training'),
              primeIcon: 'pi pi-graduation-cap',
              route: '/training',
              childs: null,
              isChildVisible: false,
            },
          ]
        : []),
    ];
  }

  getMenuListFooter(): CustomMenuItem[] {
    return [
      {
        label: this.translate.instant('menu.hub.calendar'),
        primeIcon: 'pi pi-calendar',
        route: '/calendar',
        childs: null,
        isChildVisible: false,
      },
      {
        label: this.translate.instant('menu.hub.ecoembesListens'),
        primeIcon: 'pi pi-volume-up',
        route: null,
        description: this.translate.instant(
          'menu.hub.ecoembesListensDescription',
        ),
        childs: [
          {
            label: this.translate.instant('menu.hub.sendSuggestion'),
            primeIcon: null,
            route: '/feedback',
            isChildVisible: false,
            type: 'button',
            childs: null,
          },
        ],
        isChildVisible: false,
      },
    ];
  }
  getMenuListUser(
    accountManagementDialogVisible: WritableSignal<boolean>,
    initialSelectedMenu: WritableSignal<AccountMenuKey>,
    duplicateCardDialogVisible: WritableSignal<boolean>,
  ): CustomMenuItem[] {
    return [
      {
        label: this.translate.instant('menu.user.accountManagement'),
        primeIcon: 'pi pi-user',
        command: () => {
          initialSelectedMenu.set('contracts');
          accountManagementDialogVisible.set(true);
        },
        childs: null,
        isChildVisible: false,
      },
      {
        label: this.translate.instant('menu.user.changePassword'),
        primeIcon: 'pi pi-key',
        command: () => {
          window.open(environment.changePasswordUrl, '_blank');
        },
        childs: null,
        isChildVisible: false,
      },
      {
        label: this.translate.instant('menu.user.duplicateCoordinateCard'),
        primeIcon: 'pi pi-id-card',
        command: () => {
          duplicateCardDialogVisible.set(true);
        },
        childs: null,
        isChildVisible: false,
      },
    ];
  }
}
